export default "{\n    \"parentHeading\": \"Trabajos\",\n    \"pageTitle\": \"Crear trabajo\",\n    \"newJobTitle\": \"Crear nuevo trabajo\"\n}\n"